module.exports = __webpack_public_path__ + "static/img/renz2.e02654b1.webp";